module.exports = __webpack_public_path__ + "img/complete-set.375e8ebe.png";